export const LIVE2D_MODELS = [
  {
    id: 'shizuku',
    name: 'Shizuku',
    model: 'https://unpkg.com/live2d-widget-model-shizuku@latest/assets/shizuku.model.json',
    textures: [
      'https://unpkg.com/live2d-widget-model-shizuku@latest/assets/shizuku.1024/texture_00.png'
    ],
    scale: 1,
    position: { x: 0, y: 0 },
    timeSlot: 'morning'
  },
  {
    id: 'koharu',
    name: 'Koharu',
    model: 'https://unpkg.com/live2d-widget-model-koharu@latest/assets/koharu.model.json',
    textures: [
      'https://unpkg.com/live2d-widget-model-koharu@latest/assets/koharu.1024/texture_00.png'
    ],
    scale: 1,
    position: { x: 0, y: 0 },
    timeSlot: 'noon'
  },
  {
    id: 'haruto',
    name: 'Haruto',
    model: 'https://unpkg.com/live2d-widget-model-haruto@latest/assets/haruto.model.json',
    textures: [
      'https://unpkg.com/live2d-widget-model-haruto@latest/assets/haruto.1024/texture_00.png'
    ],
    scale: 1,
    position: { x: 0, y: 0 },
    timeSlot: 'evening'
  },
  {
    id: 'miku',
    name: 'Miku',
    model: 'https://unpkg.com/live2d-widget-model-miku@latest/assets/miku.model.json',
    textures: [
      'https://unpkg.com/live2d-widget-model-miku@latest/assets/miku.1024/texture_00.png'
    ],
    scale: 1,
    position: { x: 0, y: 0 },
    timeSlot: 'night'
  }
]

export const getTimeSlotModel = () => {
  const hour = new Date().getHours()
  
  if (hour >= 6 && hour < 12) {
    return LIVE2D_MODELS.find(model => model.timeSlot === 'morning')
  } else if (hour >= 12 && hour < 18) {
    return LIVE2D_MODELS.find(model => model.timeSlot === 'noon')
  } else if (hour >= 18 && hour < 22) {
    return LIVE2D_MODELS.find(model => model.timeSlot === 'evening')
  } else {
    return LIVE2D_MODELS.find(model => model.timeSlot === 'night')
  }
}